<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

@if (authenticationService.hasWebAuthn$()) {<bowstring--form (output)="signinWithPasskeyFormSubmit(sheetComponentInput$()?.openModel$);">
  <bowstring--button
    appearance="raised"
    [disabled]="signinWithPasskeyFormWorking$()"
    level="2"
    material="inverse"
    type="submit">
    <bowstring--symbol input="PersonBadgeKeyFill" />
    @if (signinWithPasskeyFormWorking$()) {<span><span i18n>working</span>{{ ellipsesService.ellipses$() }}</span>} @else {<bowstring--label
      i18n-input
      input="Use passkey" />}
  </bowstring--button>
  <bowstring--caption i18n>Click <span style="white-space: nowrap;">&ldquo;<bowstring--symbol
    inline
    input="PersonBadgeKeyFill" />&nbsp;<bowstring--label
    i18n-input
    inline
    input="Use passkey" />&rdquo;</span> and present either biometric verification or an external security key in the next step.</bowstring--caption>
</bowstring--form>
<bowstring--divider />}
<bowstring--form (output)="signinWithPasswordFormSubmit(sheetComponentInput$()?.openModel$);">
  <bowstring--section>
    <bowstring--text-field-input
      autofocus
      autocomplete="username"
      enterKeyHint="next"
      [formControl]="signinWithPasswordFormGroup.controls.email"
      i18n-placeholder
      level="2"
      (nextFocused)="passwordInputComponent.focus();"
      placeholder="email"
      type="email" />
    <bowstring--text-field-input #passwordInputComponent
      autocomplete="current-password"
      [formControl]="signinWithPasswordFormGroup.controls.password"
      i18n-placeholder
      level="2"
      placeholder="password"
      type="password" />
  </bowstring--section>
  <bowstring--flexbox-container
    flexDirection="row"
    justifyContent="flex-end">
    <bowstring--button
      appearance="symbol"
      [disabled]="signinWithPasswordFormGroup.invalid || signinWithPasswordFormWorking$()"
      type="submit">
      <bowstring--symbol input="ArrowForwardCircleFill" />
    </bowstring--button>
  </bowstring--flexbox-container>
</bowstring--form>
